var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4337 10.433C13.2179 10.6422 13.1187 10.9447 13.1679 11.2413L13.9087 15.3413C13.9712 15.6888 13.8245 16.0405 13.5337 16.2413C13.2487 16.4497 12.8695 16.4747 12.5587 16.308L8.86786 14.383C8.73953 14.3147 8.59703 14.278 8.4512 14.2738H8.22536C8.14703 14.2855 8.07037 14.3105 8.00037 14.3488L4.3087 16.283C4.1262 16.3747 3.91953 16.4072 3.71703 16.3747C3.2237 16.2813 2.89453 15.8113 2.97537 15.3155L3.71703 11.2155C3.7662 10.9163 3.66703 10.6122 3.4512 10.3997L0.442032 7.48301C0.190365 7.23884 0.102865 6.87217 0.217865 6.54134C0.329532 6.21134 0.614532 5.97051 0.958699 5.91634L5.10037 5.31551C5.41537 5.28301 5.69203 5.09134 5.8337 4.80801L7.6587 1.06634C7.70203 0.983008 7.75787 0.906341 7.82537 0.841341L7.90036 0.783008C7.93953 0.739674 7.98453 0.703841 8.03453 0.674674L8.12537 0.641341L8.26703 0.583008H8.61786C8.9312 0.615508 9.20703 0.803008 9.3512 1.08301L11.2004 4.80801C11.3337 5.08051 11.5929 5.26967 11.892 5.31551L16.0337 5.91634C16.3837 5.96634 16.6762 6.20801 16.792 6.54134C16.9012 6.87551 16.807 7.24217 16.5504 7.48301L13.4337 10.433Z",
    fill: "#1BA75E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGreen);
export default __webpack_public_path__ + "static/media/StarGreen.2c553f5083e157b3d3c16171180f4aab.svg";
export { ForwardRef as ReactComponent };